import { memo, useMemo } from "react";
import { BaseballTable } from "../../../../components/tables/BaseballTable";
import { getTeamBattingColumns, getTeamPitchingColumns } from "../../../../config/columns";
import { Roster } from "../roster/roster";
import { TeamGames } from "../team-games/team-games";
import { PitcherUtilization } from "../pitcher-utilization/pitcher-utilization";
import { LineupUsage } from "../lineup-usage/lineup-usage";
import { TeamStatTable } from "../team-stat-table/team-stat-table";
import { STAT_TYPES } from "../../constants";

export const TeamContent = memo(({ activeTab, teamData, games, teamId, years, statData }) => {
  const battingColumns = useMemo(() => {
    const cols = getTeamBattingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  const pitchingColumns = useMemo(() => {
    const cols = getTeamPitchingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  if (activeTab === STAT_TYPES.ROSTER) return <Roster teamId={teamId} years={years} />;

  if (activeTab === STAT_TYPES.BATTING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.batting_stats || []}
          columns={battingColumns}
          filename={`${teamData?.team_name}_batting.csv`}
          noDataComponent={<div className="text-center py-12 text-gray-500">No batting data available</div>}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.PITCHING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.pitching_stats || []}
          columns={pitchingColumns}
          filename={`${teamData?.team_name}_pitching.csv`}
          noDataComponent={<div className="text-center py-12 text-gray-500">No pitching data available</div>}
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.GAMES) return <TeamGames games={games} teamName={teamData?.team_name} />;
  if (activeTab === STAT_TYPES.LINEUP) return <LineupUsage teamId={teamId} years={years} />;
  if (activeTab === STAT_TYPES.BULLPEN) return <PitcherUtilization teamId={teamId} years={years} />;

  const statTabTypes = [
    STAT_TYPES.VALUE_BATTING,
    STAT_TYPES.VALUE_PITCHING,
    STAT_TYPES.SITUATIONAL_BATTING,
    STAT_TYPES.SITUATIONAL_PITCHING,
    STAT_TYPES.SPLITS_BATTING,
    STAT_TYPES.SPLITS_PITCHING,
    STAT_TYPES.BATTED_BALL_BATTING,
    STAT_TYPES.BATTED_BALL_PITCHING,
    STAT_TYPES.BASERUNNING,
  ];

  if (statTabTypes.includes(activeTab)) {
    return (
      <div className="p-6">
        <TeamStatTable
          stats={statData?.[activeTab] || []}
          type={activeTab}
          teamName={teamData?.team_name}
        />
      </div>
    );
  }

  return null;
});

TeamContent.displayName = "TeamContent";
